import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '../../lib/utils';

interface SliderProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  className?: string;
}

export function Slider({ className, orientation = 'horizontal', ...props }: SliderProps) {
  // Upright, the track and the fill swap which way they run. Radix already
  // handles the maths and the arrow keys; only the box has to be turned.
  const upright = orientation === 'vertical';

  return (
    <SliderPrimitive.Root
      orientation={orientation}
      className={cn(
        'relative flex touch-none select-none',
        upright ? 'h-full w-5 flex-col items-center' : 'w-full items-center',
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        className={cn(
          'relative grow overflow-hidden rounded-full bg-muted',
          upright ? 'h-full w-1.5' : 'h-1.5 w-full'
        )}
      >
        <SliderPrimitive.Range
          className={cn('absolute bg-primary', upright ? 'w-full' : 'h-full')}
        />
      </SliderPrimitive.Track>
      {(props.value ?? props.defaultValue ?? [0]).map((_, i) => (
        <SliderPrimitive.Thumb
          key={i}
          className="block h-4 w-4 rounded-full border border-primary/50 bg-background shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
        />
      ))}
    </SliderPrimitive.Root>
  );
}
